import axios from "@/api/axios";

const getMenuItems = () => {
    return axios.get(`/menu-items`);
};

const getChildByParent = (id) => {
    return axios.get(`/menu-items/get-child-by-parent/${id}`);
}

const getSiblingsByTo = (to, label = null) => {
    const params = new URLSearchParams();
    params.append('to', to);
    if (label) {
        params.append('label', label);
    }
    return axios.get(`/menu-items/siblings-by-to?${params.toString()}`);
};

export default {
    getMenuItems,
    getChildByParent,
    getSiblingsByTo
};
